import React, { useEffect, useState } from "react";
import { FaPlus, FaEllipsisVertical, FaEye, FaPen } from "react-icons/fa6";
import { MdDelete, MdSearch } from "react-icons/md";
import { handleRowsPerPage } from "../../../controls/Pagination/Pagination";
import { capitalizeWords } from "../../../../utils/common";
import { getState } from "../../../../store/configure/configureStore";

import { Header, DataTable } from "../../../common";
import {
  ButtonView,
  CardView,
  Input,
  Select,
  ModalView,
} from "../../../controls";

const UserManagementView = ({
  //
  fields,
  errors,
  userData,
  userList,
  userListUpdated,
  rowsPerPage,
  showRowsPerPage,
  currentPage,
  //
  showModal,
  onClickViewUser,
  onClickAddUser,
  onClickEditUser,
  onClickDeleteUser,
  handleCloseModal,
  //
  handleInputChange,
  handleClear,
  handleRoleChange,
  handleTableRowsChange,
  handleChangePage,
  //
  onClickAddUserSubmit,
  onClickEditUserSubmit,
  onClickDeleteUserSubmit,
  onChangeSearchInput,
  onClickSearch,
  //
  roleListDropDownOptions,
  rowsPerPageDropDownOptions,
  //
  userPermissions,
}) => {
  // console.log("userData", userPermissions);
  const roleOptions =
    userData &&
    userData.roleId &&
    userData.roleId[0] &&
    userData.roleId.map((role) => ({
      value: "role.role",
      label: role.role,
    }));
  //
  const columns = [
    {
      name: "Name",
      width: "35%",
      selector: (row) => row?.userName,
    },
    {
      name: "Email",
      width: "35%",
      selector: (row) => row?.email,
    },
    {
      name: "Role",
      width: "20%",
      selector: (row) =>
        row.roleId?.length > 0 ? row?.roleId[0]?.role : "N/A",
    },
    {
      name: "Action",
      width: "10%",
      center: true,
      // cell: (row, rowIndex) => renderAction(row, rowIndex),
      cell: (row, rowIndex) => renderActionMenu(row, rowIndex),
    },
  ];

  //--------------------------View modal UI
  const renderViewBody = () => {
    const user = [
      { label: "Name", value: userData?.userName },
      { label: "Email", value: userData?.email },
      {
        label: "Role",
        value: userData && userData?.roleId ? userData?.roleId[0]?.role : "--",
        isRole: true,
      },
    ];

    return (
      <div className="body-content-wrapper view-body">
        <div className="content-wrapper">
          {user.map((item, index) => (
            <div key={index}>
              <div className={`wrapper ${item.isRole && "no-bottom-border"}`}>
                <span className="label-wrapper">{item.label}</span>
                <span className="partition">:</span>
                <span>{item.value}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  //--------------------------Add modal UI
  const renderBody = () => {
    return (
      <div className="body-content-wrapper">
        <div className="input-content-wrapper">
          {" "}
          <Input
            name="name"
            label={"Name"}
            value={capitalizeWords(fields["name"] || "")}
            placeholder="Enter name"
            isrequired={true}
            onChange={handleInputChange}
            error={errors["name"]}
            // autocomplete="new-name"
            autocomplete="off"
          />
        </div>
        <div className="input-content-wrapper">
          {" "}
          <Input
            name="email"
            label={"Email"}
            placeholder="Enter email"
            isrequired={true}
            onChange={handleInputChange}
            error={errors["email"]}
            autocomplete="new-email"
            // autocomplete="off"
          />
        </div>
        <div className="input-content-wrapper">
          {" "}
          <Input
            name="password"
            type={"password"}
            label={"Password"}
            placeholder="Enter password"
            isrequired={true}
            onChange={handleInputChange}
            error={errors["password"]}
            autocomplete="new-password"
            // autocomplete="off"
          />
        </div>
        <div className="input-content-wrapper">
          {" "}
          <Select
            name="role"
            label={"Role"}
            placeholder="Select role"
            options={roleListDropDownOptions}
            isrequired={true}
            onChange={(val) => handleRoleChange(val)}
            error={errors["role"]}
          />
        </div>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="Cancel"
            styles={"light"}
            size={"large"}
            onClick={handleCloseModal}
          />
        </div>
        <div className="action-wrapper">
          <ButtonView
            title="Submit"
            styles={"secondary"}
            size={"large"}
            onClick={() => onClickAddUserSubmit()}
          />
        </div>
      </div>
    );
  };

  //--------------------------Edit modal UI
  const renderEditBody = () => {
    const isLoggedInUserEmail =
      fields["email"] === getState().auth?.loginUser?.data?.email;

    return (
      <div className="body-content-wrapper">
        <div className="input-content-wrapper">
          {" "}
          <Input
            name="name"
            value={fields["name"]}
            label={"Name"}
            // placeholder={userData?.userName}
            isrequired={true}
            onChange={handleInputChange}
            error={errors["name"]}
            autocomplete="off"
          />
        </div>
        <div className="input-content-wrapper">
          {" "}
          <Input
            name="email"
            value={fields["email"]}
            label={"Email"}
            placeholder={userData?.email}
            isrequired={true}
            onChange={handleInputChange}
            error={errors["email"]}
            autocomplete="off"
            disabled={isLoggedInUserEmail} //if true disable
          />
        </div>
        {/* <div className="input-content-wrapper">
          {" "}
          <Input
            name="password"
            type={"password"}
            value={fields["password"]}
            label={"Password"}
            placeholder="Enter Password"
            isrequired={true}
            onChange={handleInputChange}
            error={errors["password"]}
          />
        </div> */}
        <div className="input-content-wrapper">
          {" "}
          <Select
            name="role"
            label={"Role"}
            value={fields["role"]}
            options={roleListDropDownOptions}
            isrequired={true}
            onChange={(val) => handleRoleChange(val)}
            // placeholder={roleOptions && roleOptions[0]?.label}
            error={errors["role"]}
            isDisabled={isLoggedInUserEmail} //if true disable
          />
        </div>
      </div>
    );
  };

  const renderEditFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="Cancel"
            styles={"light"}
            size={"large"}
            onClick={handleCloseModal}
          />
        </div>
        <div className="action-wrapper">
          <ButtonView
            title="Update"
            styles={"secondary"}
            size={"large"}
            onClick={() => onClickEditUserSubmit(userData?._id)}
          />
        </div>
      </div>
    );
  };

  //--------------------------Delete modal UI
  const renderDeleteBody = () => {
    return (
      <div className="body-content-wrapper delete-body">
        <div>Are you sure you want to delete this user?</div>
      </div>
    );
  };

  const renderDeleteFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="No"
            styles={"light"}
            size={"medium"}
            onClick={handleCloseModal}
          />
        </div>
        <div className="action-wrapper">
          <ButtonView
            title="Yes"
            styles={"danger"}
            size={"medium"}
            onClick={() => onClickDeleteUserSubmit(userData?._id)}
          />
        </div>
      </div>
    );
  };

  //--------------------------action UI

  // const renderActionMenu = (row) => {
  //   const isLoggedInUserEmail =
  //     row?.email === getState().auth?.loginUser?.data?.email;

  //   const menuList = [
  //     {
  //       icon: <FaEye size={15} color="#B6C7AA" title="View" />,

  //       onclick: () => {
  //         onClickViewUser(row);
  //       },
  //     },
  //     userPermissions?.includes("edit_user") && {
  //       icon: <FaPen size={15} color="#4B70F5" title="Edit" />,

  //       onclick: () => {
  //         onClickEditUser(row);
  //       },
  //     },
  //     userPermissions?.includes("delete_user") && {
  //       icon: <MdDelete size={15} color="#FF0000" title="Delete" />,

  //       onclick: () => {
  //         onClickDeleteUser(row);
  //       },
  //       hide: isLoggedInUserEmail,
  //     },
  //   ];

  //   return (
  //     <div className="action-menu-wrapper d-flex gap-3">
  //       {menuList
  //         .filter((item) => !item?.hide) // Exclude items where hide is true.
  //         .map((item, index) => (
  //           <div key={index} className="menu-item" onClick={item?.onclick}>
  //             {item?.icon}
  //           </div>
  //         ))}
  //     </div>
  //   );

  //   // return (
  //   //   <div className="action-menu-wrapper d-flex gap-3">
  //   //     {menuList.map((item) => {
  //   //       return (
  //   //         <div className="menu-item" onClick={item?.onclick}>
  //   //           {item?.icon}
  //   //         </div>
  //   //       );
  //   //     })}
  //   //   </div>
  //   // );
  // };

  const renderActionMenu = (row) => {
    const isLoggedInUserEmail =
      row?.email === getState().auth?.loginUser?.data?.email;

    const menuList = [
      {
        icon: <FaEye size={15} color="#B6C7AA" title="View" />,
        onclick: () => {
          onClickViewUser(row);
        },
        hide: false, // Ensure View is always visible
      },
      {
        icon: <FaPen size={15} color="#4B70F5" title="Edit" />,
        onclick: () => {
          onClickEditUser(row);
        },
        hide: !userPermissions?.includes("edit_user"),
      },
      {
        icon: <MdDelete size={15} color="#FF0000" title="Delete" />,
        onclick: () => {
          onClickDeleteUser(row);
        },
        hide: !userPermissions?.includes("delete_user") || isLoggedInUserEmail,
      },
    ];

    return (
      <div className="action-menu-wrapper d-flex gap-3">
        {menuList.map((item, index) => (
          <div
            key={index}
            className={`menu-item ${item.hide ? "invisible" : ""}`}
            onClick={!item.hide ? item.onclick : null}
          >
            {item.icon}
          </div>
        ))}
      </div>
    );
  };

  // console.log("userList Updated", userList);
  return (
    <div className="user__management--container">
      <div className="user__management--header-wrapper">
        <div className="title-content">User Management</div>
        <div className="action-btn-wrapper">
          {userPermissions?.includes("add_user") && (
            <ButtonView
              title="Add User"
              styles={"secondary"}
              icon={<FaPlus />}
              onClick={onClickAddUser}
            />
          )}
        </div>
      </div>
      <div className="user__management--table-wrapper">
        <div className="controls-wrapper">
          <div className="row-control-wrapper">
            <Select
              value={rowsPerPage}
              placeholder={10}
              options={rowsPerPageDropDownOptions}
              onChange={(val) => {
                handleTableRowsChange(val);
              }}
              isRowCap={true}
            />{" "}
            entries per page
          </div>
          <div className="row-control-wrapper">
            Search:{" "}
            <Input
              name={"searchValue"}
              value={fields?.searchValue}
              isrequired={true}
              onChange={(e) => onChangeSearchInput(e)}
              placeholder={"Type here to search"}
              showClearIcon={fields?.searchValue ? true : false}
              handleClear={handleClear}
              // error={"Please provide valid input"}
              error={errors["searchValue"]}
              isSearchInput={true}
              autocomplete="off"
            />
            <div className="search-action-wrapper">
              <ButtonView
                // title="Search"
                icon={<MdSearch size={20} color="#eca55a" />}
                styles={"secondary"}
                size={"medium btn"}
                onClick={() => onClickSearch()}
              />
            </div>
          </div>
        </div>
        <div className="table-content">
          <DataTable
            columns={columns}
            data={userList?.docs ? userList?.docs : []}
            highlightOnHover={true}
            pointerOnHover={true}
            fixedHeader={true}
            persistTableHead={true}
            //
            pagination={true}
            paginationServer={true}
            paginationPerPage={userList?.limit}
            paginationTotalRows={userList?.totalDocs}
            onChangeRowsPerPage={handleTableRowsChange}
            onChangePage={handleChangePage}
            currentPage={currentPage}
            //
          />
        </div>
      </div>
      <ModalView
        show={showModal.showViewModal}
        handleClose={handleCloseModal}
        center={true}
        showCloseIcon={true}
        title={"User Details"}
        children={renderViewBody()}
      />
      <ModalView
        show={showModal.showAddModal}
        handleClose={handleCloseModal}
        center={true}
        showCloseIcon={true}
        title={"Add User"}
        modalHeaderStyles={"add-user-modal-header"}
        children={renderBody()}
        modalBodyStyles={"add-user-modal-body"}
        footer={renderFooter()}
        modalFooterStyles={"add-user-modal-footer"}
      />
      <ModalView
        show={showModal.showEditModal}
        handleClose={handleCloseModal}
        center={true}
        showCloseIcon={true}
        title={"Edit User"}
        children={renderEditBody()}
        footer={renderEditFooter()}
      />
      <ModalView
        show={showModal.showDeleteModal}
        handleClose={handleCloseModal}
        modalHeaderStyles={"delete-modal-header"}
        modalBodyStyles={"delete-modal-body"}
        modalFooterStyles={"delete-modal-footer"}
        center={true}
        showCloseIcon={true}
        title={"Delete"}
        children={renderDeleteBody()}
        footer={renderDeleteFooter()}
      />
    </div>
  );
};

export default UserManagementView;
